export default {"src":"/_next/static/media/pause_bold.e4b93b82.svg","height":24,"width":24};